import React, { useEffect, useReducer } from "react";
import Fab from "@mui/material/Fab";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { useForm, Controller } from "react-hook-form";
import GroupIcon from "@mui/icons-material/Group";
import clsx from "clsx";

// Custom.
import { useStyles } from "./styles";
import VoTextField from "@vocollege/components/dist/VoTextField";
import { getTemporaryId } from "@vocollege/app/dist/modules/VoHelpers";
import { BatchPersonListProps, BatchPersonListItem } from "./global";
import EditDialog from "@vocollege/components/dist/EditDialog";
import { reducer, regexPatterns } from "@vocollege/app/dist/modules/VoHelpers";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

// export const initialRowState = {
//   id: "",
//   firstname: "",
//   lastname: "",
//   personal_number: "",
// };

export const initialState = {
  rows: [],
  openDialog: false,
  items: [],
};

const BatchPersonList: React.FC<BatchPersonListProps> = (props) => {
  const {
    className,
    buttonLabel,
    onChange,
    fields = ["firstname", "lastname", "personal_number"],
    initialData,
    disableFields,
    content,
  } = props;
  const classes = useStyles();
  // const [rows, setRows] = useState<BatchPersonListItem[]>([
  //   { ...initialState },
  // ]);
  const [state, dispatch] = useReducer(reducer, initialState);
  // const { control, setValue, formState, reset, getValues } = useForm({
  //   mode: "onChange",
  // });
  const { control, formState, setValue } = useForm({
    mode: "onChange",
  });
  // const { isDirty, isValid, errors } = formState;
  const { errors } = formState;

  // Methods.

  const addItem = (reset = false) => {
    let id = `${getTemporaryId()}${state.rows.length}`;
    let newValues = !reset ? [...state.rows] : [];
    newValues.push({ ...{ id } });
    dispatch({
      key: "rows",
      values: newValues,
      // values: [...state.rows, { ...{ id } }],
      // values: [...state.rows, { ...{ ...initialRowState, id } }],
    });
  };

  const removeItem = (id: string) => {
    let newRows = state.rows.filter((v: BatchPersonListItem) => v.id !== id);
    dispatch({ key: "rows", values: [...newRows] });
  };

  const handleChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    let newRows = [...state.rows];
    newRows[index][name] = value;
    dispatch({ key: "rows", values: newRows });
    setValue(`${name}` as const, value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const parseItemsData = (
    data: BatchPersonListItem[]
  ): BatchPersonListItem[] => {
    let items: BatchPersonListItem[] = data.map((v: BatchPersonListItem) => {
      return {
        // id: v.id,
        firstname: v[`firstname_${v.id}`],
        lastname: v[`lastname_${v.id}`],
        personal_number: v[`personal_number_${v.id}`],
      };
    });

    return items;
  };

  const handleConfirm = () => {
    if (!onChange) {
      return;
    }
    let items = parseItemsData(state.rows);
    onChange(items);
    dispatch({ values: { openDialog: false, items } });
  };

  const getButtonLabel = () => {
    if (buttonLabel) {
      return buttonLabel;
    }
    return `${I18n.get.vocertList.labels.handlePersons} (${state.items.length})`;
  };

  const hasField = (field: string) => {
    return fields && fields.indexOf(field) > -1;
  };

  // Effect.

  useEffect(() => {
    if (state.rows.length === 0) {
      addItem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state.openDialog && state.items.length === 0) {
      addItem(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.openDialog]);

  useEffect(() => {
    let newRows: BatchPersonListItem[] = [];
    let newItems: BatchPersonListItem[] = [];
    if (initialData) {
      newRows = initialData.map((v: BatchPersonListItem) => ({
        id: v.id,
        [`firstname_${v.id}`]: v.firstname,
        [`lastname_${v.id}`]: v.lastname,
        [`personal_number_${v.id}`]: v.personal_number,
      }));
      // newItems = parseItemsData(initialData);
      // newItems = initialData.map((v: BatchPersonListItem) => ({
      //   firstname: v.firstane
      // }));

      // let newItems = fields.reduce((o: any, i) => {
      //   console.log("o", o);

      //   return o && o[i];
      // }, initialData);

      newItems = initialData.map((v: BatchPersonListItem) => ({
        // id: v.id,
        firstname: v.firstname,
        lastname: v.lastname,
        personal_number: v.personal_number,
      }));

      if (onChange) {
        onChange(newItems);
      }
    }

    dispatch({
      values: {
        rows: newRows,
        items: newItems,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData]);

  return (
    <>
      <Button
        className={clsx(className)}
        variant="contained"
        startIcon={<GroupIcon />}
        onClick={() => dispatch({ key: "openDialog", values: true })}
      >
        {getButtonLabel()}
      </Button>
      <EditDialog
        className={classes.dialogRoot}
        open={state.openDialog}
        onConfirm={handleConfirm}
        onCancel={() => dispatch({ key: "openDialog", values: false })}
        saveDisabled={!formState?.isDirty || !formState?.isValid}
        title={I18n.get.vocertList.labels.handlePersons}
      >
        {content && <div className={classes.content}>{content}</div>}
        <div className={classes.rows}>
          {state.rows.map((row: BatchPersonListItem, i: number) => (
            <Grid key={i} className={classes.row} spacing={2} container>
              <Grid item xs={12} md={hasField("personal_number") ? 4 : 6}>
                <Controller
                  name={`firstname_${row.id}`}
                  control={control}
                  rules={{
                    required: I18n.get.form.errors.required,
                  }}
                  render={({ field }) => (
                    <VoTextField
                      {...field}
                      label={I18n.get.user.labels.firstname}
                      variant="filled"
                      fullWidth
                      required
                      onChange={(event: any) => handleChange(i, event)}
                      value={field.name in row ? row[field.name] : ""}
                      size="small"
                      error={!!errors[field.name]}
                      helperText={
                        errors[field.name] &&
                        (`${errors[field.name]?.message}` as string)
                      }
                      disabled={disableFields}
                    />
                  )}
                />{" "}
              </Grid>
              <Grid item xs={12} md={hasField("personal_number") ? 4 : true}>
                <Controller
                  name={`lastname_${row.id}`}
                  control={control}
                  rules={{
                    required: I18n.get.form.errors.required,
                  }}
                  render={({ field }) => (
                    <VoTextField
                      {...field}
                      label={I18n.get.user.labels.lastname}
                      variant="filled"
                      fullWidth
                      required
                      onChange={(event: any) => handleChange(i, event)}
                      value={field.name in row ? row[field.name] : ""}
                      size="small"
                      error={!!errors[field.name]}
                      helperText={
                        errors[field.name] &&
                        (`${errors[field.name]?.message}` as string)
                      }
                      disabled={disableFields}
                    />
                  )}
                />
              </Grid>
              {hasField("personal_number") && (
                <Grid item xs={12} md>
                  <Controller
                    name={`personal_number_${row.id}`}
                    control={control}
                    rules={{
                      validate: (value: any) => {
                        if (!value || value === "") {
                          return true;
                        }
                        return (
                          !!value.match(regexPatterns.personalNumber) ||
                          I18n.get.form.errors.personalNumberInvalid
                        );
                      },
                    }}
                    render={({ field }) => (
                      <VoTextField
                        {...field}
                        variant="filled"
                        onChange={(event: any) => handleChange(i, event)}
                        value={field.name in row ? row[field.name] : ""}
                        label={I18n.get.user.labels.personalNumber}
                        fullWidth
                        size="small"
                        error={!!errors[field.name]}
                        helperText={
                          errors[field.name] &&
                          (`${errors[field.name]?.message}` as string)
                        }
                        disabled={disableFields}
                      />
                    )}
                  />
                </Grid>
              )}
              {!disableFields && state.rows.length > 1 && (
                <Grid item>
                  <IconButton
                    aria-label="delete"
                    onClick={() => row.id && removeItem(row.id)}
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          ))}
        </div>
        {!disableFields && (
          <div className={classes.actions}>
            <Fab
              className={classes.addButton}
              size="small"
              color="secondary"
              aria-label="add item"
              onClick={() => addItem()}
            >
              <AddIcon />
            </Fab>
          </div>
        )}
      </EditDialog>
    </>
  );
};

export default BatchPersonList;
